import { AuthUser } from 'app/auth/auth.service';

const FALLBACK_INITIALS = '?';

export function initialsOf(user: Pick<AuthUser, 'name'>): string {
  const words = user.name.trim().split(/\s+/).filter(Boolean);
  return words.length > 0 ? firstAndLastLetter(words) : FALLBACK_INITIALS;
}

function firstAndLastLetter(words: string[]): string {
  const first = words[0];
  const last = words.length > 1 ? words[words.length - 1] : '';
  return (first[0] + last.charAt(0)).toUpperCase();
}
